import { React } from "react";
import { Link } from "react-router-dom";


import astronaut from "../../assets/img/astronaut.jpeg";
import abstractLine from "../../assets/img/abstractLine.jpg";
import forest from "../../assets/img/forest.jpg";
import town from "../../assets/img/town.jpg";
import space from "../../assets/img/space.jpg";
import Spline from "@splinetool/react-spline";

import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ServicesComponent() {
  gsap.registerPlugin(ScrollTrigger);

  useGSAP(() => {
    const entries = document.querySelectorAll(".scroll-entry");
    entries.forEach((entry) => {
      let entryMain = entry.querySelectorAll(".entry_main");
      let entrySecondary = entry.querySelectorAll(".entry_secondary");

      gsap.set(entryMain, {
        xPercent: -150,
        opacity: 0,
      });
      gsap.set(entrySecondary, {
        xPercent: 150,
        opacity: 0,
      });
      gsap.to(entryMain, {
        scrollTrigger: {
          trigger: entry,
          start: "10% bottom",
          end: "bottom 90%",
          scrub: true,
        },
        xPercent: 0,
        opacity: 1,
      });
      gsap.to(entrySecondary, {
        scrollTrigger: {
          trigger: entry,
          start: "10% bottom",
          end: "bottom 90%",
          scrub: true,
        },
        xPercent: 0,
        opacity: 1,
      });
    });
  });
  

  return (
    <>
      <section className="container fullstack services scroll-entry">
        <div className="content entry_main">
          <h1>
            Here’s what we <br /> are good at
          </h1>
          
          <h2>Full-cycle development</h2>
          <p>
            As a full-cycle developer, we build your software from scratch,
            including the user interface and back end.
          </p>
          <Link to="/service/full-cycle">
            <div className="button ">
              <p>Learn more details</p>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M18.3828 10.8828C18.8711 10.3945 18.8711 9.60156 18.3828 9.11328L12.1328 2.86328C11.6445 2.375 10.8516 2.375 10.3633 2.86328C9.875 3.35156 9.875 4.14453 10.3633 4.63281L15.7305 10L10.3672 15.3672C9.87891 15.8555 9.87891 16.6484 10.3672 17.1367C10.8555 17.625 11.6484 17.625 12.1367 17.1367L18.3867 10.8867L18.3828 10.8828ZM4.63281 17.1328L10.8828 10.8828C11.3711 10.3945 11.3711 9.60156 10.8828 9.11328L4.63281 2.86328C4.14453 2.375 3.35156 2.375 2.86328 2.86328C2.375 3.35156 2.375 4.14453 2.86328 4.63281L8.23047 10L2.86719 15.3672C2.37891 15.8555 2.37891 16.6484 2.86719 17.1367C3.35547 17.625 4.14844 17.625 4.63672 17.1367L4.63281 17.1328Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
          </Link>
        </div>
        <div className="fullstack-animation entry_secondary">
          <Spline scene="https://prod.spline.design/b1JwKP9dNMc31tRm/scene.splinecode" />
        </div>
      </section>
      <div className="container services">
        <section className="frame-section ">
          <div className="frame-wrapper scroll-entry">
            <div className="frame-left entry_main">
              <div className="frame-title">
                <h3>Bespoke Solutions for your Unique Digital Presence</h3>
              </div>
              <p>
                We kick templates to the curb and handcraft web solutions
                tailor-made for your brand's distinct identity. From whimsical
                to professional, we've got you covered!
              </p>
            </div>
            <div className="frame-image entry_secondary">
              <img src={astronaut} alt="" />
            </div>
          </div>
          <div className="frame-wrapper scroll-entry">
            <div className="frame-left entry_secondary">
              <div className="frame-title">
                <h3>Hosting an Array of Web Development Services</h3>
              </div>
              <p>
                Our expertise doesn't just stop at website creation. We offer
                services spanning landing page design, redesigns and more, all
                with our innovative 3D twist.
              </p>
            </div>
            <div className="frame-image entry_main">
              <img src={abstractLine} alt="" />
            </div>
          </div>
        </section>
      </div>
      <section className="container services scroll-entry">
        <div className="carts-section entry_secondary">
          <div className="grid">
            <div className="item">
              <div className="image">
                <img src={town} alt="Urban Revamp" />
              </div>
              <div className="content">
                <h2>Urban Revamp</h2>
                <p>
                  We transformed a local food blog into a bustling, online
                  metropolis. Talk about taking things to the next dimension!
                </p>
              </div>
            </div>
            <div className="item">
              <div className="image">
                <img src={space} alt="Urban Revamp" />
              </div>
              <div className="content">
                <h2>Space Sailing</h2>
                <p>
                  Our client’s website now feels like taking a cruise through
                  galaxy. Shooting stars included!
                </p>
              </div>
            </div>
            <div className="item">
              <div className="image">
                <img src={forest} alt="Urban Revamp" />
              </div>
              <div className="content">
                <h2>Nature's Portal</h2>
                <p>
                  We gave a travel website the power to take their users on a
                  journey through the wilderness before they ever leave their
                  house.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container services scroll-entry">
        <div className="faq">
          <h1>Got Queries? We've got Answers.</h1>
          <div className="content">
            <div className="item entry_main">
              <h5>Elevate your website experience</h5>
              <p>
                Websites that offer an immersive and engaging experience can
                give your digital presence the attention it deserves, setting it
                apart from the competition
              </p>
            </div>
            <div className="item entry_secondary">
              <h5>Can you handle my site's redesign?</h5>
              <p>
                Absolutely! Our team loves transforming drab, outdated websites
                into stunning, interactive masterpieces.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="container services scroll-entry">
        <div className="simplify">
          <span className="post-title">Simplify</span>
          <h1>Transform Your Website</h1>
          <p>
            <span>&lt;div&gt;</span> We create stunning websites that captivate
            your audience and drive results. <span>&lt;/div&gt;</span>
          </p>
        </div>
      </section>
    </>
  );
}
